"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.b64DecodeUnicode = exports.b64EncodeUnicode = void 0;
const b64EncodeUnicode = (plainText) => {
    return window.btoa(encodeURIComponent(plainText).replace(/%([0-9A-F]{2})/g, (match, p1) => {
        return String.fromCharCode(parseInt('0x' + p1, 16));
    }));
};
exports.b64EncodeUnicode = b64EncodeUnicode;
const b64DecodeUnicode = (encodedString) => {
    return decodeURIComponent(Array.prototype.map
        .call(window.atob(encodedString), c => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(''));
};
exports.b64DecodeUnicode = b64DecodeUnicode;
